import { useShouldShowDevTeamFeature } from './_base';

export const usePhysicalMetricsFeature: () => boolean = useShouldShowDevTeamFeature;
